import { Icon } from '@iconify/react';
import database from '@iconify/icons-ant-design/database-outlined';
// import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import fileSearch from '@iconify/icons-ant-design/file-search-outlined';
import plusOutlined from '@iconify/icons-ant-design/plus-circle-outlined';
import safetyCertificateOutlined from '@iconify/icons-ant-design/safety-certificate-outline';
import teamOutlined from '@iconify/icons-ant-design/team-outlined';
import AntDesignCopyOutlined from '@iconify/icons-ant-design/copy-outlined';
import AntDesignCameraTwotone from '@iconify/icons-ant-design/camera-twotone';
import pieChartOutline from '@iconify/icons-eva/pie-chart-outline';
import UploadIcon from '@iconify/icons-ant-design/upload';
// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const getSidebarConfig = () => [
  {
    title: 'Virtual Racks',
    path: '/racks',
    icon: getIcon(database)
  },
  {
    title: 'New VRack',
    path: '/createrack',
    icon: getIcon(plusOutlined)
  },
  {
    title: 'Snapshots',
    path: '/snapshots',
    icon: getIcon(AntDesignCameraTwotone)
  },
  {
    title: 'VM Templates',
    path: '/vmtemplates',
    icon: getIcon(AntDesignCopyOutlined)
  },
  {
    title: 'Loadables',
    path: '/upload',
    icon: getIcon(UploadIcon)
  },
  {
    title: 'Team Management',
    path: '/teams',
    icon: getIcon(teamOutlined)
  },
  {
    title: 'Reporting',
    icon: getIcon(pieChartOutline),
    children: [
      {
        title: 'Billing',
        path: '/billing'
      },
      {
        title: 'Team Usage',
        path: '/team-usage'
      }
    ]
  },
  {
    title: 'Documentation',
    icon: getIcon(fileSearch),
    children: [
      {
        title: 'Release Notes',
        path: '/static/help-system-guide/release_notes.html',
        target: '_blank',
        external: true
      },
      {
        title: 'User Guide',
        path: '/static/help-system-guide/virtual_rack_home.html',
        target: '_blank',
        external: true
      },
      {
        title: 'Troubleshooting Guide',
        path: '/static/help-system-guide/PDFs/Virtual%20Rack%20Troubleshooting%20Guide.pdf',
        target: '_blank',
        external: true
      },
      {
        title: 'Vrackctl Installation Guide',
        path: '/static/help-system-guide/PDFs/Virtual%20Rack%20CLI%20Installation%20Guide.pdf',
        target: '_blank',
        external: true
      },
      {
        title: 'Vrackctl Developer Guide',
        path: '/static/help-system-guide/PDFs/Virtual%20Rack%20CLI%20Developer%20Guide.pdf',
        target: '_blank',
        external: true
      },
      {
        title: 'MikroTik Onboarding Guide',
        path: '/static/help-system-guide/PDFs/MikroTik%20Dual%20Point%20Connector%20Onboarding%20Guide.pdf',
        target: '_blank',
        external: true
      }
    ]
  },
  {
    title: 'Admin',
    children: [
      {
        title: 'Companies',
        path: '/admin/companies'
      },
      {
        title: 'Users',
        path: '/admin/users'
      },
      {
        title: 'Policies',
        path: '/admin/policies'
      },
      {
        title: 'Global Admins',
        path: '/admin/global-admins'
      },
      {
        title: 'Settings',
        path: '/admin/settings'
      }
    ],
    icon: getIcon(safetyCertificateOutlined)
  }
];

export default getSidebarConfig;
